import React from "react";
import { classNames } from "../../../../general/functions/propsComponent";
import {
  CameraVideoFill,
  CameraVideoOffFill,
  MicFill,
  MicMuteFill,
  TelephoneFill,
} from "react-bootstrap-icons";

export default function KonselorControlDummy() {
  return (
    <div className="grid grid-cols-3 w-[95%] mx-auto">
      <div className="flex gap-2 ">
        <button
          className={classNames(
            true ? "on" : "",
            "btn-default02 p-2 w-12 h-12 flex flex-col justify-center items-center rounded-full"
          )}
        >
          <MicMuteFill size={16} className="text-red-500" />
        </button>
        <button
          className={classNames(
            // tracksState.video
            true ? "on" : "",
            "btn-default02 p-2 w-12 h-12 rounded-full flex flex-col justify-center items-center"
          )}
        >
          <CameraVideoOffFill size={16} className="text-red-500" />
        </button>
      </div>
      <div className="flex gap-2 flex-col items-center">
        <p className="text-white text-sm leading-3">Duration</p>
        <p className="text-white text-2xl  leading-4">00:00</p>
      </div>
      <div className="flex gap-2 justify-end relative">
        <button
          className={classNames(
            "btn-primary bg-red-500 p-2 w-14 h-14 flex flex-col justify-center items-center whitespace-nowrap rounded-full absolute -top-1"
          )}
          //   onClick={() => leaveChannel()}
        >
          <p className="text-sm font-semibold">
            <TelephoneFill size={24} className="rotate-[135deg] " />{" "}
          </p>
        </button>
      </div>
    </div>
  );
}
